import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
} from '@mui/material';
import CustomCard from '../../../../components/ui/customCard';

export function VipCustomersTable({ customers }) {
  return (
    <CustomCard>
<Table>
      <TableHead>
        <TableRow>
          <TableCell>Client</TableCell>
          <TableCell>Événements</TableCell>
          <TableCell>Total dépensé</TableCell>
          <TableCell>Statut</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {customers.map((c) => (
          <TableRow key={c.id}>
            <TableCell>{c.name}</TableCell>
            <TableCell>{c.events}</TableCell>
            <TableCell>{c.amount} FCFA</TableCell>
            <TableCell>
              <Chip label="VIP" color="primary" size="small" />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
    </CustomCard>
    
  );
}
